import type { Right, User } from "@/services/user/userTypes";
import { readonly } from "vue";

const user = ref<User>();

export function useUser() {
  const hasRight = (right: Right): boolean => {
    return user.value?.rights.includes(right) ?? false;
  };

  const isUserLoggedIn = computed(() => user.value !== undefined);

  // -----------------------------------
  // Shortcuts
  // -----------------------------------

  const avatar = computed(() => user.value?.avatar);

  const userId = computed(() => user.value?.id);

  return {
    user,
    userId,
    avatar,

    hasRight,
    isUserLoggedIn: readonly(isUserLoggedIn),
  };
}
